import { useState } from 'react'

export function useAlert()
{
    const [alert, setAlert] = useState({
        show: false,
        variant: '',
        header: '',
        message: ''
    })

    function showAlert(variant, header, message)
    {
        setAlert({
            show: true,
            variant, 
            header,
            message
        })
    }

    function closeAlert()
    {
        setAlert(prevAlert => ({
            ...prevAlert,
            show: false
        }))
    }

    return {alert, showAlert, closeAlert}
} 

export function WarningIncompleteInputMessage()
{
    return {
        "variant": "warning", 
        "header": "Faltou preencher algum valor!", 
        "body": "Certifique-se de preencher todos os campos obrigatórios e usar ponto para números decimais (ex.: 312.15)"
    }
}

export function WarningInvalidInput(formErrors)
{
    return {
        "variant": "warning", 
        "header":  "Opa! Tem algo errado nos dados informados", 
        "body": formErrors.concat("\n")
    }
}

export function ErrorChamadaApi(apiName, errorMessage)
{
    return {
        "variant": "danger", 
        "header":  "Ocorreu um erro ao se comunicar com a aplicação " + apiName, 
        "body": "Por favor, informe o responsável pelo sistema.\n" + errorMessage
    }
}